<div>
  <div class="tab-option-panel">
    <div>
      <kendo-dropdownlist
        [disabled]="checkAllGridDataLength()"
        [(ngModel)]="rotate"
        [data]="rotationList"
        [valueField]="'id'"
        (valueChange)="rotationChange()"
        placeholder="'_General_Rotation_Text_' | translate"
        [textField]="'displayValue'"
      >
      </kendo-dropdownlist>
    </div>
    <div (mouseenter)="mouseEnter()" title="{{ disableButonsToolTip }}">
      <button
        [disabled]="rotationList.length == 1 || isSaveDisabled == false"
        (click)="onToggleMove()"
        class="btn btn-primary"
      >
        {{ "_User_Availability_Template_Move_Button_Text_" | translate }}
      </button>
      <button
        [disabled]="rotationList.length == 1 || isSaveDisabled == false"
        (click)="onToggleRemove()"
        class="btn btn-primary"
      >
        {{ "_User_Availability_Template_Remove_Button_Text_" | translate }}
      </button>
      <button
        [disabled]="rotationList.length == 1 || isSaveDisabled == false"
        (click)="onToggleOccurs('OPEN')"
        class="btn btn-primary"
      >
        {{ "_User_Availability_Template_Occurs_Button_Text_" | translate }}
      </button>
      <button
        [disabled]="
          isAvailabilityTimeRangesValid == false ||
          isSaveDisabled == false ||
          rotationList.length >= 5
        "
        (click)="onToggle()"
        class="btn btn-primary"
      >
        {{ "_General_Button_Add_Text_" | translate }}
      </button>
    </div>
  </div>
  <div class="d-flex">
    <div class="cc-validation validation-note mb-2" *ngIf="appointmentsEnabled">
      {{ "_User_Availability_Meeting_Preference_Validation_Text_" | translate }}
    </div>
  </div>

  <kendo-grid
    id="mainGrid"
    [data]="
      availabilityGridDataNew.length >= 0
        ? availabilityGridDataDisplay
        : availabilityGridDataNew[0].availabilityTempateDay
    "
    [sortable]="true"
    [pageable]="false"
    scrollable="scrollable"
  >
    <kendo-grid-messages
      pagerFirstPage="{{ '_Go_To_First_Page_Text_' | translate }}"
      pagerLastPage="{{ '_Go_To_Last_Page_Text_' | translate }}"
      pagerNextPage="{{ '_Go_To_Next_Page_Text_' | translate }}"
      pagerPreviousPage="{{ '_Go_To_Previous_Page_Text_' | translate }}"
      pagerPage="{{ '_Page_Grid_Text_' | translate }}"
      noRecords="{{ '_NoRecords_Grid_Text_' | translate }}"
      pagerItems="{{ '_General_Kendo_Grid_Pageable_Items_Text_' | translate }}"
      pagerOf="{{ '_General_Kendo_Grid_Pageable_Of_Text_' | translate }}"
    ></kendo-grid-messages>

    <kendo-grid-column
      title="{{
        '_User_Availability_Availability_Column_Title_Text_' | translate
      }}"
      [width]="105"
      [headerStyle]="{
        'font-weight': 'bold',
        'text-align': 'center',
        'justify-content': 'center',
      }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="cell-items-center">
          <input
            kendoCheckBox
            class="checkbox-cell"
            (change)="checkedChanged(dataItem)"
            type="checkbox"
            [checked]="!dataItem.isAvailable == false"
          />
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="dayOfWeek"
      title="{{ '_General_Day_Of_Week_Text_' | translate }}"
      [width]="120"
      [sortable]="false"
      [headerStyle]="{ 'font-weight': 'bold' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <p>{{ transformDay(dataItem.dayOfWeek) | translate }}</p>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ '_General_Start_Time_Text_' | translate }}"
      [width]="150"
      [headerStyle]="{ 'font-weight': 'bold' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div
          class="mb-2"
          *ngFor="
            let timerange of dataItem.availabilityTimeRange;
            let i = index
          "
        >
          <!--onkeydown="return false;"-->
          <kendo-timepicker
            [steps]="{ hour: 1, minute: 15, second: 00 }"
            [readOnlyInput]="true"
            (valueChange)="onStartTimeChange(dataItem, startTime.value, i)"
            [format]="'HH:mm'"
            [value]="timerange.startTime"
            [disabled]="dataItem.isAvailable == false"
            #startTime
          >
            <kendo-timepicker-messages
              cancel="{{ '_General_Button_Cancel_Text_' | translate }}"
              accept="{{ '_General_Button_Set_Text_' | translate }}"
              acceptLabel="{{ '_General_Set_Time_Text_' | translate }}"
              cancelLabel="{{ '_General_Cancel_Changes_Text_' | translate }}"
              toggle="{{ '_General_Toggle_Text_' | translate }}"
            >
            </kendo-timepicker-messages>
          </kendo-timepicker>
          <!--<div *ngIf="!timerange.isStartTimeOverlapped && timerange.isStartTimeValid && (!timerange.isEndTimeValid || timerange.isEndTimeOverlapped)"
                        [ngClass]="!timerange.isEndTimeValid ? 'timepicker-range-error-padding' : 'timepicker-overlap-error-padding'"></div>-->
          <div *ngIf="!timerange.isStartTimeValid" class="cc-validation">
            {{ "_General_Start_Time_Validation_Text_" | translate }}
          </div>
          <div
            *ngIf="
              timerange.isStartTimeValid && timerange.isStartTimeOverlapped
            "
            class="cc-validation"
          >
            {{ "_General_Invalid_Start_Time_Text_" | translate }}
          </div>
          <!--Change to maintain consistency with location op hours-->
          <!-- <div *ngIf="timerange.isDuplicateTime" class="cc-validation">Duplicate Time Slot</div> -->
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ '_General_End_Time_Text_' | translate }}"
      [width]="150"
      [headerStyle]="{ 'font-weight': 'bold' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div
          class="mb-2"
          *ngFor="
            let timerange of dataItem.availabilityTimeRange;
            let i = index
          "
        >
          <!-- onkeydown="return false;"-->
          <kendo-timepicker
            [steps]="{ hour: 1, minute: 15, second: 00 }"
            [readOnlyInput]="true"
            (valueChange)="onEndTimeChange(dataItem, endTime.value, i)"
            [value]="timerange.endTime"
            [format]="'HH:mm'"
            [disabled]="dataItem.isAvailable == false"
            #endTime
          >
            <kendo-timepicker-messages
              cancel="{{ '_General_Button_Cancel_Text_' | translate }}"
              accept="{{ '_General_Button_Set_Text_' | translate }}"
              acceptLabel="{{ '_General_Set_Time_Text_' | translate }}"
              cancelLabel="{{ '_General_Cancel_Changes_Text_' | translate }}"
              toggle="{{ '_General_Toggle_Text_' | translate }}"
            ></kendo-timepicker-messages>
          </kendo-timepicker>
          <!--<div *ngIf="!timerange.isEndTimeOverlapped && timerange.isEndTimeValid && (!timerange.isStartTimeValid || timerange.isStartTimeOverlapped)"
                        [ngClass]="!timerange.isStartTimeValid ? 'timepicker-range-error-padding' : 'timepicker-overlap-error-padding'"></div>-->
          <div *ngIf="!timerange.isEndTimeValid" class="cc-validation">
            {{ "_General_End_Time_Validation_Text_" | translate }}
          </div>
          <div
            *ngIf="timerange.isEndTimeValid && timerange.isEndTimeOverlapped"
            class="cc-validation"
          >
            {{ "_General_Invalid_End_Time_Text_" | translate }}
          </div>
          <!--Change to maintain consistency with location op hours-->
          <!-- <div *ngIf="timerange.isDuplicateTime" class="cc-validation">Duplicate Time Slot</div> -->
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{
        '_User_Availability_Work_Locations_Column_Title_Text_' | translate
      }}"
      [width]="200"
      [sortable]="false"
      [headerStyle]="{ 'font-weight': 'bold' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div
          class="mb-2"
          *ngFor="
            let timerange of dataItem.availabilityTimeRange;
            let i = index
          "
        >
          <kendo-dropdownlist
            [data]="userWorkLocationList"
            [valueField]="'id'"
            [valuePrimitive]="true"
            [disabled]="dataItem.isAvailable == false"
            [textField]="'locationName'"
            (valueChange)="
              onWorkLocationChange(dataItem, workLocationTemplateValue.value, i)
            "
            [defaultItem]="defaultItem"
            [value]="timerange.userWorkLocation"
            #workLocationTemplateValue
          >
          </kendo-dropdownlist>
        </div>
        <!-- {{workLocation |json}} -->
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      title="{{ '_General_Meeting_Preferences_Text_' | translate }}"
      [width]="180"
      [sortable]="false"
      [headerStyle]="{ 'font-weight': 'bold' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div
          class="mb-2"
          *ngFor="
            let timerange of dataItem.availabilityTimeRange;
            let i = index
          "
        >
          <div *ngIf="i == 0">
            <div *ngIf="appointmentsEnabled">
              <!--[disabled]=dataItem.dayOfWeek==0 || -->
              <ng-multiselect-dropdown
                [ngClass]="
                  timerange.selectedMeetingPreference.length < 2
                    ? 'cc-multi-select cc-multi-select-disabled cc-multi-select-chip-disabled'
                    : 'cc-multi-select'
                "
                [(ngModel)]="timerange.selectedMeetingPreference"
                [settings]="dropdownSettings"
                [data]="allMPs[timerange.userHoursOfOperationId]"
                (onDeSelect)="
                  onDeSelectMeetingPreference(
                    $event,
                    timerange,
                    timerange.userHoursOfOperationId
                  )
                "
                (onSelect)="
                  onSelectMeetingPreference(
                    $event,
                    timerange,
                    timerange.userHoursOfOperationId
                  )
                "
                [disabled]="
                  dataItem.isAvailable == false ||
                  (meetingPreferenceList && meetingPreferenceList.length < 2)
                "
              >
              </ng-multiselect-dropdown>
              <!--*ngIf=dataItem.dayOfWeek!=0-->
              <div
                *ngIf="
                  dataItem.isAvailable &&
                  (!timerange.selectedMeetingPreference ||
                    timerange.selectedMeetingPreference.length == 0)
                "
              >
                <div class="cc-validation opt-hours-validation">
                  {{
                    "_General_Meeting_Preference_Option_Should_Select_Text_"
                      | translate
                  }}
                </div>
              </div>
            </div>

            <div *ngIf="!appointmentsEnabled">
              {{
                "_User_Availability_Not_Applicable_Validation_Text_" | translate
              }}
            </div>
          </div>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="{{ '_General_Button_Action_Text_' | translate }}"
      [width]="100"
      [sortable]="false"
      [headerStyle]="{
        'font-weight': 'bold',
        'text-align': 'center',
        'justify-content': 'center',
      }"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="cell-items-center flex-column align-items-center">
          <span
            class="rotation-action"
            *ngFor="
              let timerange of dataItem.availabilityTimeRange;
              let i = index
            "
          >
            <button
              [ngClass]="
                dataItem.isAvailable == false
                  ? 'cc-icon-btn cc-icon-btn-disabled'
                  : 'cc-icon-btn'
              "
              *ngIf="i != 0"
              [disabled]="dataItem.isAvailable == false"
              title="{{ '_General_Button_Delete_Text_' | translate }}"
              (click)="deleteItem(dataItem.availabilityTimeRange, rowIndex, i)"
            >
              <span class="fas fa-trash-alt"></span>
            </button>
            <!--[ngClass] & [disabled] = dataItem.dayOfWeek==0 || -->
            <button
              [ngClass]="
                dataItem.isAvailable == false ||
                dataItem.availabilityTimeRange.length >= 10
                  ? 'cc-icon-btn cc-icon-btn-disabled'
                  : 'cc-icon-btn'
              "
              *ngIf="i == 0"
              [disabled]="
                dataItem.isAvailable == false ||
                dataItem.availabilityTimeRange.length >= 10
              "
              title="{{ '_General_Button_Add_Text_' | translate }}"
              (click)="addItem(dataItem, timerange)"
            >
              <span class="fas fa-plus"></span>
            </button>
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
  <!--    <div>{{availabilityGridData|json}}</div> -->

  <!-- Button Panel -->
  <div class="cc-btn-panel">
    <button (click)="cancelClicked()" class="btn btn-secondary">
      {{ "_General_Button_Close_Text_" | translate }}
    </button>
    <button
      (click)="saveClicked()"
      class="btn btn-primary"
      [disabled]="isSaveButtonDisabled()"
    >
      {{ "_General_Button_Save_Text_" | translate }}
    </button>
  </div>
</div>

<kendo-dialog
  [minWidth]="300"
  [width]="500"
  title="{{ '_User_Availability_Confirmation_Popup_Title_Text_' | translate }}"
  *ngIf="show"
  (close)="onNoClicked()"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>
  <div class="d-flex align-items-center">
    <p class="pe-2">
      {{ "_User_Availability_Confirmation_Popup_Message_Text_" | translate }}
    </p>
    <kendo-dropdownlist
      [(ngModel)]="selectedRotation"
      [data]="rotationList"
      [valueField]="'id'"
      placeholder="Rotation"
      [textField]="'displayValue'"
    >
    </kendo-dropdownlist>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button class="btn btn-primary" (click)="onYesClicked()">
      {{ "_General_Action_Label_Yes_Text_" | translate }}
    </button>
    <button class="btn btn-secondary" (click)="onNoClicked()">
      {{ "_General_Action_Label_No_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  [minWidth]="300"
  title="{{
    '_User_Availability_Rotation_Pattern_View_Popup_Title_Text_' | translate
  }}"
  *ngIf="show1"
  (close)="onToggleOccurs('CLOSE')"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>
  <div class="d-flex flex-row justify-content-start select-rot">
    <p>
      {{ "_User_Availability_Selected_Rotation_Text_" | translate }}
      {{ rotationId }}
    </p>
  </div>
  <div class="d-flex flex-row justify-content-start">
    <kendo-calendar
      selection="multiple"
      [min]="rotationStartDate"
      [max]="rotationEndDate"
      class="calander"
    >
      <kendo-calendar-messages
        today="{{ '_General_Today_Text_' | translate }}"
      ></kendo-calendar-messages>
      <ng-template kendoCalendarMonthCellTemplate let-date>
        <span [ngClass]="isMeeting(date)">{{ date.getDate() }}</span>
      </ng-template>
      <ng-template
        kendoCalendarNavigationItemTemplate
        let-title
        let-date="date"
        let-view="activeView"
      >
        {{ view === "month" && date.getMonth() === 0 ? "Jan" : title }}
      </ng-template>
    </kendo-calendar>
  </div>
  <!-- <ngb-multi-date-picker [datesSelected]="datesSelected" (datesSelectedChange)="change($event)">
            </ngb-multi-date-picker> -->
  <kendo-dialog-actions class="cc-btn-panel">
    <button class="btn btn-secondary" (click)="onToggleOccurs('CLOSE')">
      {{ "_General_Button_Close_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  [minWidth]="300"
  [width]="500"
  title="{{ '_User_Availability_Move_Rotation_Text_' | translate }}"
  *ngIf="show2"
  (close)="onToggleMoveNo()"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>
  <div class="d-flex align-items-center">
    <p class="pe-2">
      {{
        "_User_Availability_Place_Text_"
          | translate: { value0: rotate.displayValue }
      }}
    </p>

    <kendo-dropdownlist
      #selected
      [data]="moveList"
      [valueField]="'id'"
      placeholder="Rotation"
      [textField]="'displayValue'"
    >
    </kendo-dropdownlist>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button class="btn btn-primary" (click)="onMove(rotate, selected.value)">
      {{ "_General_Action_Label_Yes_Text_" | translate }}
    </button>
    <button class="btn btn-secondary" (click)="onToggleMoveNo()">
      {{ "_General_Action_Label_No_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  [minWidth]="300"
  [width]="500"
  title="{{
    '_User_Availability_Rotation_Pattern_Unable_To_Save_Availability_Template_Changes_Title_Text_'
      | translate
  }}"
  *ngIf="showUnsaveChangesInAppointmentPopup"
  (close)="onCloseUnsaveChangesInAppointmentPopup()"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>
  <div class="d-flex align-items-center">
    <p class="pr-2">
      {{
        "_User_Availability_Rotation_Pattern_Unable_To_Save_Availability_Template_Changes_Unsaved_Data_Message_Text_"
          | translate
      }}
    </p>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button
      class="btn btn-primary"
      (click)="onCloseUnsaveChangesInAppointmentPopup()"
    >
      {{ "_General_Button_Ok_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  [minWidth]="300"
  [width]="500"
  title="{{
    '_User_Availability_Remove_Rotation_Popup_Title_Text_' | translate
  }}"
  *ngIf="showRemove"
  (close)="onNoRemoveClicked()"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>
  <p class="pe-2">
    {{
      "_User_Availability_Rotation_Deletion_Text_"
        | translate: { val1: rotationId }
    }}
  </p>
  <kendo-dialog-actions class="cc-btn-panel">
    <button class="btn btn-primary" (click)="onRemoveClicked()">
      {{ "_General_Action_Label_Yes_Text_" | translate }}
    </button>
    <button class="btn btn-secondary" (click)="onNoRemoveClicked()">
      {{ "_General_Action_Label_No_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
